import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { PessoaList } from 'app/modules/auth'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { ProfissionalDeSaudeColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const ProfissionalDeSaudeTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => ProfissionalDeSaudeColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum profissional encontrado para “${filters.nome.trim()}”`}
      description='Revise o nome digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum profissional cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro profissional de saúde.'
    />
  )

  return (
    <CustomTable<PessoaList>
      id='kt_table_profissionais'
      ariaLabel='Profissionais de saúde'
      itemLabel={{ singular: 'profissional', plural: 'profissionais' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
